module.exports = __webpack_public_path__ + "img/staff-and-payroll.9610d7bb.svg";